import React from 'react';
import { Box } from '@tanium/react-box';
import { SpaceStyleProps } from '@tanium/style-system';
import { Fill, Shadow } from './themeDefinitions';

export interface Props extends SpaceStyleProps {
  /**
   * The tile's contents.
   */
  children: React.ReactNode;
}

// This type cast provides better typings and Intellisense for consumers
export const Tile = React.forwardRef<HTMLDivElement, Props>((props, ref) => (
  <Box ref={ref} bg={Fill} boxShadow={Shadow} borderRadius="4px" p={2} {...props} />
)) as React.VFC<Props & { ref?: React.Ref<HTMLDivElement> }>;
